<template>
    <div ref="cutEditRoot" class="cut-item">
        <img class="cut-image" :src="cutImage.baseImage">

        <div v-show="cutImage.showLines && context.showLines" class="cut-edit-layer" ref="cutEditLayer"> </div>

    </div>
</template>

<script>

import {
    drawLinesOnKonva,
} from "./DicomCutReports";

export default {
    name: "DicomCutItem",
    props: {
        context: {
            type: Object,
            required: true
        },
        cutImage: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            konvaStage: null,
            konvaLayer: null
        }
    },
    watch: {
        "cutImage": {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal && this.$refs.cutEditLayer) {
                    console.log(`cutImage changed`, newVal.cutShift, this.$refs.cutEditLayer.children);
                    this.initKonva();
                    this.updateKonvaLines();
                }
            }
        },
        "context.nerveLineLogic": {
            // immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    let index = this.context.nerveLineLogic.index;
                    console.log(`nerveLineLogic changed`, index);
                    drawLinesOnKonva(this.cutImage, this.konvaStage, this.konvaLayer);
                }
            }
        },
        "context.widthColor": {
            // immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    console.log(`widthColor changed`, newVal);
                    drawLinesOnKonva(this.cutImage, this.konvaStage, this.konvaLayer);
                }
            }
        },
        "context.measureColor": {
            // immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    console.log(`measureColor changed`, newVal);
                    drawLinesOnKonva(this.cutImage, this.konvaStage, this.konvaLayer);
                }
            }
        },
        "context.nerveColor": {
            // immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    console.log(`nerveColor changed`, newVal);
                    drawLinesOnKonva(this.cutImage, this.konvaStage, this.konvaLayer);
                }
            }
        },
        "context.imagesPerLine": {
            // immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    console.log(`imagesPerLine changed`, newVal);
                    let actualRect = this.$refs.cutEditRoot.getBoundingClientRect();
                    if (!actualRect.width || !actualRect.height) {
                        actualRect = this.$refs.cutEditLayer.children[0].getBoundingClientRect();
                    }
                    if (!actualRect.width || !actualRect.height) {
                        return;
                    }
                    this.konvaStage.width(actualRect.width);
                    this.konvaStage.height(actualRect.height);
                    drawLinesOnKonva(this.cutImage, this.konvaStage, this.konvaLayer, true);
                }
            }
        },
        "context.panoWidth": {
            // immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    let actualRect = this.$refs.cutEditRoot.getBoundingClientRect();
                    if (!actualRect.width || !actualRect.height) {
                        actualRect = this.$refs.cutEditLayer.children[0].getBoundingClientRect();
                    }
                    if (!actualRect.width || !actualRect.height) {
                        return;
                    }

                    console.log(`panoWidth changed`, newVal, actualRect);
                    this.konvaStage.width(actualRect.width);
                    this.konvaStage.height(actualRect.height);
                    drawLinesOnKonva(this.cutImage, this.konvaStage, this.konvaLayer, true);
                }
            }
        },
    },
    mounted() {
        // const dentationSuffix = this.cutImage.isUpper ? "u" : "l";
        // const editLayerId = `mounted ${this.cutImage.cutShift}`;
        // console.log(editLayerId, this.$refs.cutEditLayer.children);

        this.initKonva();
        this.updateKonvaLines();
    },

    methods: {
        initKonva: function () {
            let children = this.$refs.cutEditLayer.children;
            if (!this.konvaStage || !children || !children.length) {
                // const editLayerId = `cutEditLayer${this.cutImage.cutShift}`;
                // this.$refs.cutEditLayer.setAttribute("id", editLayerId);
                const actualRect = this.$refs.cutEditRoot.getBoundingClientRect();
                this.konvaStage = new Konva.Stage({
                    container: this.$refs.cutEditLayer, // id of container <div>
                    width: actualRect.width,
                    height: actualRect.height,
                });
                this.konvaStage.isOriginal = true;
                this.konvaLayer = new Konva.Layer();
                this.konvaStage.add(this.konvaLayer);
            }

        },
        updateKonvaLines: function () {
            this.konvaLayer.destroyChildren();
            this.cutImage.konvaStage = this.konvaStage;
            this.cutImage.konvaLayer = this.konvaLayer;
            drawLinesOnKonva(this.cutImage, this.konvaStage, this.konvaLayer, true);
        }
    }
};

</script>

<style scoped>
.cut-item {
    width: 100%;
    height: 100%;
    position: relative;
}

.cut-image {
    position: absolute;
    width: 100%;
    height: 100%;
    /* image-rendering: pixelated; */
}

.cut-edit-layer {
    position: absolute;
    width: 100%;
    height: 100%;
}
</style>